import { ambiente } from '../../shared/utils/Enum';
export const envConfig = {
  REACT_APP_NOME_AMBIENTE: ambiente.local,
  REACT_APP_NAME: '$npm_package_name',
  REACT_APP_VERSION: '$npm_package_version',
};
